import { Validation } from "../../validators"
import { FormValidationController } from "../form_validation_controller"
import { events } from "../../utils/events"

// Valida el formulario con el que un promotor resuelve una incidencia. Los campos son dinamicos
// (dependen de que marco el analista), asi que cada input declara su llave de validacion en
// data-validation-key en lugar de derivarla del id del DOM.
export default class extends FormValidationController {
  connect() {
    this.eventForInputType = events
    this.validation = new Validation()
    this.validatableInputs = []
    this.errors = {}
    this.newRecord = ''

    this.bindInputs()
    this.bindSelects()
    this.bindForm()
  }

  render(target, validation) {
    const validator = validation.find((validator) => !validator.result.valid)

    if (validator) {
      this.renderValidation(target, validator)
    } else {
      this.clearValidation(target)
    }
  }

  renderValidation(target, validator) {
    target.classList.add('invalid')

    const help = this.errorLabelFor(target)
    if (!help) return

    help.classList.add('show')
    help.innerHTML = validator.result.message
  }

  clearValidation(target) {
    target.classList.remove('invalid')

    const help = this.errorLabelFor(target)
    if (!help) return

    help.classList.remove('show')
    help.innerHTML = ''
  }

  errorLabelFor(target) {
    return target.closest('fieldset')?.querySelector('.error-label')
  }
}
